import {onFind} from "@elements/init-modules-in-scope";
import {findAllIn, findIn, on, addClass, toggleClass, hasClass, removeClass, find} from '@elements/dom-utils';

let selectors = {
    base: '.js-facilities-map',
    btn: '.js-facilities-map__btn',
    mapBtn: '.js-facilities-map__btn-map',
    iframeWrapper: '.js-facilities-map__iframe-wrapper',
    iframe: '.js-facilities-map__iframe'
}
export function init() {
    onFind(selectors.base, function (baseElement) {
        let btn = findAllIn(selectors.btn, baseElement);
        btn.map((btn) => {
            on('click', function () {
                let iframe = findIn(selectors.iframe, baseElement);


                let iframeContent = `<iframe style="width: 100%; height: 100%;"
                                                allowFullScreen
                                                src="${btn.getAttribute('data-src')}"
                                                frameBorder="0"></iframe>`;


                iframe.innerHTML = iframeContent;

                let mapIcon= findIn('.icon', mapBtn);
                removeClass('icon-map', mapIcon);
                addClass('icon-close', mapIcon);
                addClass('is-shown', iframe);
                scrollTop(iframe);
            }, btn);
        });
        let iframe = findIn(selectors.iframe, baseElement);
        let mapBtn = findIn(selectors.mapBtn, baseElement);
        let mapIcon= findIn('.icon', mapBtn);
        on('click', function () {
            if(hasClass('icon-map', mapIcon)){
                scrollTop(iframe);
                removeClass('icon-map', mapIcon);
                addClass('icon-close', mapIcon);
                addClass('is-shown', iframe);
            }else{
                addClass('icon-map', mapIcon);
                removeClass('icon-close', mapIcon);
                removeClass('is-shown', iframe);
            }
        }, mapBtn);

    });
}

export function scrollTop(iframe){
    let bodyRect = document.body.getBoundingClientRect().top;
    let elementRect = iframe.getBoundingClientRect().top;
    let elementPosition = elementRect - bodyRect;
    let offsetPosition = elementPosition - 200;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}
